import React from 'react';
import CustomMarkdownRenderer from './CustomMarkdownRenderer';

const HybridAssessmentRenderer = ({ evaluationResult }) => {
  // Parse the result if it's a string
  let parsedResult;
  try {
    parsedResult = typeof evaluationResult === 'string' 
      ? JSON.parse(evaluationResult) 
      : evaluationResult;
  } catch (error) {
    // If parsing fails, treat as plain markdown
    return <CustomMarkdownRenderer markdownContent={evaluationResult} />;
  }
  
  // Check if we have the hybrid format (both markdown and structured data)
  if (parsedResult && (parsedResult.markdown || parsedResult.structured)) {
    // Even with structured data, we still render the markdown for this component
    // as we're using the structured data separately for visualizations
    if (parsedResult.markdown) {
      return <CustomMarkdownRenderer markdownContent={parsedResult.markdown} />;
    }
  }
  
  // Legacy support for plain markdown string
  return <CustomMarkdownRenderer markdownContent={evaluationResult} />;
};

export default HybridAssessmentRenderer;